/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal } from '@/components/Layout';
import './quizz.css';
import folderIcon from '@/assets/icons/folder.svg';
import uploadIcon from '@/assets/icons/upload-success.svg';
import { useEffect, useId } from 'react';
import UploadQuizzInput from './UploadQuizzInput';

import { ListItem } from '@/components/Ui';
import { QuestionInput } from '@/api/gql/graphql';
import { useQuestionLogic } from '@/hooks/useQuestionLogic';

const TABS = [
  { label: '1 - Upload', id: 0 },
  { label: '2 - Récap', id: 1 },
  { label: '3 - Terminer', id: 2 },
];

const UploadQuizz = ({ type }: { type: 'quizz' | 'evaluation' }) => {
  const id = useId();
  const {
    activeTab,
    file,
    handleFileChange,
    handleNext,
    handlePrevious,
    handleSend,
    isOpenQuizModal,
    openQuizModal,
    quizData,
    setQuizData,
    handleSelectedQuizz,
    selectedQuizz,
    setActiveTab,
    setFile,
    setDocument,
    addMultipleQuestion,
    loadingAddQuestionForExercise
  } = useQuestionLogic();

  useEffect(() => {
    setQuizData([]);
    setActiveTab(0);
    setDocument(null);
  }, [isOpenQuizModal, setQuizData, setActiveTab, setDocument]);

  const renderTabHeader = () =>
    TABS.map((tab) => (
      <li
        key={tab.id}
        className={`relative pl-4 pr-4 after:content-['']
          after:w-full after:h-1 after:absolute after:bottom-[-1.125rem] 
          after:transition-[background-color] after:duration-300 
          after:ease-linear after:left-0 ${
            activeTab === tab.id
              ? 'after:bg-primary text-white'
              : 'text-[#7d7d7d]'
          }`}
      >
        {tab.label}
      </li>
    ));

  const renderUploadSection = () => (
    <div className="flex flex-col gap-6 w-full min-h-[18.75rem] mt-16">
      <div className="flex justify-center items-center rounded-2xl border-[1.5px] border-dashed border-[#555555] py-8">
        <UploadQuizzInput
          fileName={file}
          icon={folderIcon}
          id={`${id}-file`}
          onchange={handleFileChange(setFile)}
          accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </div>
    </div>
  );

  const renderRecapSection = () => (
    <div className="flex flex-col p-10 pt-6 overflow-x-hidden overflow-y-auto mb-4">
      {quizData.map((item: QuestionInput, index) => (
        <div key={index} onClick={() => handleSelectedQuizz(item)}>
          <ListItem
            connector
            listItemStyle="!bg-black"
            leftBorderColor="#FEC200"
            connectorStyle="before:h-[calc(100%_-_20px)]"
            focused={item === selectedQuizz}
            subItems={item.responses
              .filter((res) => res.response !== '')
              .map((res) => ({
                connector: true,
                children: (
                  <div>
                    <p className="text-white text-[10px]">{res.response}</p>
                  </div>
                ),
                leftBorderColor: res.isRight ? '#2ecc71' : '#EA242C',
              }))}
          >
            <p>{item.name}</p>
            <p className="text-[9.75px] font-normal leading-3 text-left text-[#939393] pt-1">
              Type {item.type}
            </p>
          </ListItem>
        </div>
      ))}
    </div>
  );

  const renderCompletionSection = () => (
    <div className="flex flex-col justify-center items-center pt-9">
      <div className="flex items-center justify-center w-20 h-20">
        <img src={uploadIcon} className="min-w-full" />
      </div>
      <p className="text-[64px] font-extrabold leading-[75.14px] text-left text-white">
        Upload réussi !!
      </p>
      <p className="text-primary">
        {quizData.length} questions seront uploadées
      </p>
    </div>
  );

  const buttonStyles =
    'cursor-pointer font-medium px-[3em] py-[0.5em] rounded-lg border-[none]';

  const getLeftButtonLabel = () => {
    if (activeTab === 0) return 'Annuler';
    return 'Précédent';
  };

  const getLeftButtonStyle = () => {
    if (activeTab === 0) return 'bg-[#BD292F]';
    return 'bg-[#555555]';
  };

  const handleLeftButtonClick = () => {
    if (activeTab === 0) {
      openQuizModal();
    } else {
      handlePrevious();
    }
  };

  const isLastStep = activeTab === 2;

  return (
    <Modal
      isOpen={isOpenQuizModal}
      onClose={openQuizModal}
      headerStyle="bg-[#2A2A2A]"
      modalStyle="p-0"
    >
      <div className="flex flex-col justify-between h-[70vh] w-[60vw] bg-[#2A2A2A] px-10 pb-10">
        <div className="w-full pb-4 border-b-2 border-b-[#636363] border-solid">
          <ul className="flex justify-between">{renderTabHeader()}</ul>
        </div>

        {activeTab === 0 && renderUploadSection()}
        {activeTab === 1 && renderRecapSection()}
        {activeTab === 2 && renderCompletionSection()}

        <div className="w-full flex items-center gap-4 justify-between">
          <button
            onClick={handleLeftButtonClick}
            className={`${buttonStyles} text-white ${getLeftButtonStyle()}`}
          >
            {getLeftButtonLabel()}
          </button>
          <button
            onClick={
              isLastStep
                ? type === 'quizz'
                  ? handleSend
                  : addMultipleQuestion
                : handleNext
            }
            className={`${buttonStyles} bg-[#FEC200] text-black`}
          >
            {isLastStep ? loadingAddQuestionForExercise ? 'En cours...' : 'Terminer' : 'Suivant'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadQuizz;
